import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

let lenis: Lenis | null = null;

export function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return false;
  if (lenis) lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
}

export function SmoothScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const instance = new Lenis({ duration: 1.15, smoothWheel: true });
    lenis = instance;
    let frame = 0;
    const raf = (t: number) => {
      instance.raf(t);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      instance.destroy();
      lenis = null;
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    lenis?.scrollTo(0, { immediate: true });
    return undefined;
  }, [pathname, hash]);

  return null;
}
